module.exports = __webpack_public_path__ + "img/notifications.021254e7.svg";